import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface TimeoutDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-timeout-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
      <mat-progress-bar mode="determinate" [value]="progressValue"></mat-progress-bar>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button color="primary" (click)="stayActive()">Stay Active</button>
      <button mat-button (click)="logOut()">Log Out</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-progress-bar {
      margin-top: 20px;
    }
  `]
})
export class TimeoutDialogComponent implements OnInit, OnDestroy {
  progressValue = 100;
  private intervalId: any;
  private readonly TOTAL_TIME = 30000; // 30 seconds
  private readonly UPDATE_INTERVAL = 100; // Update progress every 100ms

  constructor(
    public dialogRef: MatDialogRef<TimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TimeoutDialogData
  ) {}

  ngOnInit(): void {
    this.startProgressBar();
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }

  stayActive(): void {
    this.dialogRef.close(true);
  }

  logOut(): void {
    this.dialogRef.close(false);
  }

  private startProgressBar(): void {
    const decrementValue = (this.UPDATE_INTERVAL / this.TOTAL_TIME) * 100;
    
    this.intervalId = setInterval(() => {
      this.progressValue -= decrementValue;
      
      if (this.progressValue <= 0) {
        this.clearInterval();
        this.progressValue = 0;
      }
    }, this.UPDATE_INTERVAL);
  }

  private clearInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
